import { inject } from '@angular/core';
import { LayoutService } from './layout.service';

export function initializeLayout() {
    const layoutService = inject(LayoutService);
    return layoutService.init();
}
